import { Suspense } from 'react';

import './pageSuspenseFallback.scss';


function PageSuspenseFallback({ children }) {
  return (
    <Suspense fallback={
      <div className='PageSuspenseFallback' role='status' aria-live='polite'>
        <span className='PageSuspenseFallback_spinner' aria-hidden='true'></span>
        <span className='PageSuspenseFallback_text' dir='rtl'>يتم التحميل ...</span>
      </div>
    }>
      {children}
    </Suspense>
  );
}

export default PageSuspenseFallback;
